import router from './router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

NProgress.configure({ showSpinner: false })

const AI_CHAT_ROUTES = ['/ai-chat', '/ai-chat/image-cut-diagram']

router.beforeEach((to, _from, next) => {
  NProgress.start()

  document.body.setAttribute('data-route', to.path)
  document.getElementById('app')?.setAttribute('data-route', to.path)

  if (to.meta.title) {
    document.title = to.meta.title as string
  }

  if (AI_CHAT_ROUTES.includes(to.path) || to.redirectedFrom) {
    next()
    return
  }

  next('/ai-chat')
})

router.afterEach(() => {
  NProgress.done()
})
